import React from 'react'
import { Image_Url } from '../../constants/imageUrl/ImageUrl'

const ImagePopup = ({ isOpen, imageUrl, selectedImage, onClose }) => {
  return (
    isOpen && selectedImage && (
        <div className='popup-images'>
          <img alt="img" className='large-image' src={selectedImage ? selectedImage : imageUrl} />
          <img src={Image_Url.CROSSICONS} className='cross-img' onClick={onClose} />
        </div>
      )
  )
}

export default ImagePopup